import { axiosInstance } from 'boot/axios.js'

export async function save(ctx, data) {
  try {
    const response = await axiosInstance({
      url: '/user-sessions',
      method: 'POST',
      data: data
    })
    ctx.commit('item', response.data)
    return response
  } catch (e) {
    throw e
  }
}
